import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "language",
    get: function get() {
      return AppModule.language;
    }
  }, {
    key: "handleSetLanguage",
    value: function handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      AppModule.SetLanguage(lang);
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'Login'
})], default_1);
export default default_1;